import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, isRef as _isRef, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-9f5007c8"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "con2"
}
const _hoisted_2 = { class: "p-t-40" }
const _hoisted_3 = { class: "p-b-30" }
const _hoisted_4 = ["src"]
const _hoisted_5 = {
  key: 1,
  class: "con"
}
const _hoisted_6 = { class: "title" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, null, -1))

import { ref, reactive, onMounted, computed } from "vue";
import store from "@/store";
import type { FormInstance, FormRules } from "element-plus";
import { CircleCheckFilled } from "@element-plus/icons-vue";
import { addContactUs, contactUsFormType } from "@/api/request/contactUs";
import { getDictList, dictItemType } from "@/api/request";

import { ElMessage, ElMessageBox } from "element-plus";
import { useI18n } from "vue-i18n";
import finished from "@/assets/operate/faq/finished.png";


export default /*#__PURE__*/_defineComponent({
  __name: 'contactUs',
  setup(__props) {

const { t } = useI18n();
// 联系我们
const contactUsVisible = computed(() => {  
  return store.state.user.contactUsVisible;
});
const close = () => {
  submitSuccess.value = false;
  formBtnLoading.value = false;
  store.commit("SET_CONTACTUSVISIBLE", false);
};
const submitSuccess = ref(false);
const formBtnLoading = ref(false);
const validateEmail = (rule: any, value: any, callback: any) => {
  if (value !== "") {
    const reg = /\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*/;
    if (reg.test(value)) {
      callback();
    } else {
      callback(new Error(t("请输入正确格式")));
    }
  } else {
    callback();
  }
};
const validateMobile = (rule: any, value: any, callback: any) => {
  if (value !== "") {
    const reg = /^(0|86|17951)?1[0-9]{10}$/;
    if (reg.test(value)) {
      callback();
    } else {
      callback(new Error(t("请输入正确格式")));
    }
  } else {
    callback();
  }
};
const formRules = reactive<FormRules>({
  name: [{ required: true, message: t("请输入您的全名"), trigger: "blur" }],
  company: [{ required: true, message: t("请输入公司名称"), trigger: "blur" }],
  salesName: [
    { required: true, message: t("请输入销售名称"), trigger: "blur" },
  ],
  email: [
    { required: true, message: t("请输入您的邮箱"), trigger: "blur" },
    { validator: validateEmail, trigger: "blur" },
  ],
  mobile: [{ validator: validateMobile, trigger: "blur" }],
  industry: [
    { required: true, message: t("请选择所属行业"), trigger: "change" },
  ],
  question: [
    { required: true, message: t("请描述一下您的问题"), trigger: "blur" },
  ],
});

const contactUsForm = reactive<contactUsFormType>({
  name: "",
  company: "",
  salesName: "",
  email: "",
  mobile: "",
  industry: "",
  question: "",
});
const contactUsFormRef = ref<FormInstance>();
const addSubmit = async (formEl: FormInstance | undefined) => {
  const formStr = JSON.stringify(contactUsForm);
  const pattern = /[<>']/;
  if (pattern.test(formStr)) {
    return ElMessage.error("禁止填入非法信息");
  }
  if (!formEl) return;
  await formEl.validate((valid) => {
    if (valid) {
      formBtnLoading.value = true;
      addContactUs({ ...contactUsForm })
        .then(() => {
          ElMessage.success(t("提交成功"));
          formEl.resetFields();
          submitSuccess.value = true;
        })
        .finally(() => {
          formBtnLoading.value = false;
        });
      // ElMessageBox.confirm('确认提交吗？', '提示', {
      // 	confirmButtonText: '确定',
      // 	cancelButtonText: '取消',
      // 	type: 'info',
      // })
      // 	.then(() => {
      // 		formBtnLoading.value = true;
      // 		addContactUs({ ...contactUsForm })
      // 			.then(() => {
      // 				ElMessage.success('提交成功');
      // 				formEl.resetFields();
      // 				submitSuccess.value = true;
      // 			})
      // 			.finally(() => {
      // 				formBtnLoading.value = false;
      // 			});
      // 	})
      // 	.catch(() => {
      // 		// 取消
      // 	});
    }
  });
};

// 行业
const industryList = ref([] as dictItemType[]);
onMounted(() => {
  getDictList({ type: "industry_list" }).then((res) => {
    industryList.value = res.data;
  });
});

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createBlock(_component_el_dialog, {
    modelValue: _unref(contactUsVisible),
    "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (_isRef(contactUsVisible) ? (contactUsVisible).value = $event : null)),
    class: "contactUsDialog",
    "destroy-on-close": "",
    "align-center": "",
    "before-close": close
  }, {
    default: _withCtx(() => [
      (submitSuccess.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("img", {
                  src: _unref(finished),
                  alt: "",
                  width: "60"
                }, null, 8, _hoisted_4)
              ]),
              _createElementVNode("div", null, _toDisplayString(_ctx.$t("收到您的提交")), 1)
            ]),
            _createElementVNode("div", null, _toDisplayString(_ctx.$t("我们会在 48 小时内跟您联系！")), 1),
            _createElementVNode("div", null, [
              _createVNode(_component_el_button, {
                type: "danger",
                round: "",
                plain: "",
                size: "large",
                onClick: close
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t("完成")), 1)
                ]),
                _: 1
              })
            ])
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _hoisted_7,
              _createTextVNode(_toDisplayString(_ctx.$t("联系我们")), 1)
            ]),
            _createVNode(_component_el_form, {
              ref_key: "contactUsFormRef",
              ref: contactUsFormRef,
              model: contactUsForm,
              rules: formRules,
              "label-width": "150px",
              size: "large",
              "label-position": "left"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_form_item, {
                  label: _ctx.$t('怎么称呼您'),
                  prop: "name"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      modelValue: contactUsForm.name,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((contactUsForm.name) = $event)),
                      placeholder: _ctx.$t('请输入您的全名'),
                      maxlength: "20",
                      "show-word-limit": ""
                    }, null, 8, ["modelValue", "placeholder"])
                  ]),
                  _: 1
                }, 8, ["label"]),
                _createVNode(_component_el_form_item, {
                  label: _ctx.$t('您的公司名称'),
                  prop: "company"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      modelValue: contactUsForm.company,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((contactUsForm.company) = $event)),
                      placeholder: _ctx.$t('请输入公司名称'),
                      maxlength: "50",
                      "show-word-limit": ""
                    }, null, 8, ["modelValue", "placeholder"])
                  ]),
                  _: 1
                }, 8, ["label"]),
                _createVNode(_component_el_form_item, {
                  label: _ctx.$t('销售姓名'),
                  prop: "salesName"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      modelValue: contactUsForm.salesName,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((contactUsForm.salesName) = $event)),
                      placeholder: _ctx.$t('请输入销售的姓名'),
                      maxlength: "20",
                      "show-word-limit": ""
                    }, null, 8, ["modelValue", "placeholder"])
                  ]),
                  _: 1
                }, 8, ["label"]),
                _createVNode(_component_el_form_item, {
                  label: _ctx.$t('邮箱'),
                  prop: "email"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      modelValue: contactUsForm.email,
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((contactUsForm.email) = $event)),
                      placeholder: _ctx.$t('请输入您的邮箱'),
                      maxlength: "50",
                      "show-word-limit": ""
                    }, null, 8, ["modelValue", "placeholder"])
                  ]),
                  _: 1
                }, 8, ["label"]),
                _createVNode(_component_el_form_item, {
                  label: _ctx.$t('手机（选填）'),
                  prop: "mobile"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      modelValue: contactUsForm.mobile,
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((contactUsForm.mobile) = $event)),
                      placeholder: _ctx.$t('请输入您的手机号码'),
                      maxlength: "20",
                      "show-word-limit": ""
                    }, null, 8, ["modelValue", "placeholder"])
                  ]),
                  _: 1
                }, 8, ["label"]),
                _createVNode(_component_el_form_item, {
                  label: _ctx.$t('行业'),
                  prop: "industry"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_select, {
                      class: "select-width",
                      modelValue: contactUsForm.industry,
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((contactUsForm.industry) = $event)),
                      placeholder: _ctx.$t('请选择所属行业')
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(industryList.value, (item) => {
                          return (_openBlock(), _createBlock(_component_el_option, {
                            key: item.id,
                            label: item.label,
                            value: item.label
                          }, null, 8, ["label", "value"]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["modelValue", "placeholder"])
                  ]),
                  _: 1
                }, 8, ["label"]),
                _createVNode(_component_el_form_item, {
                  label: _ctx.$t('您的问题'),
                  prop: "question"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      type: "textarea",
                      rows: 5,
                      maxlength: "200",
                      "show-word-limit": "",
                      modelValue: contactUsForm.question,
                      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((contactUsForm.question) = $event)),
                      placeholder: _ctx.$t('请简述一下您的问题')
                    }, null, 8, ["modelValue", "placeholder"])
                  ]),
                  _: 1
                }, 8, ["label"]),
                _createVNode(_component_el_form_item, { "label-width": "0px" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_button, {
                      loading: formBtnLoading.value,
                      type: "info",
                      round: "",
                      size: "large",
                      onClick: _cache[7] || (_cache[7] = ($event: any) => (addSubmit(contactUsFormRef.value)))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t("提交")), 1)
                      ]),
                      _: 1
                    }, 8, ["loading"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["model", "rules"])
          ]))
    ]),
    _: 1
  }, 8, ["modelValue"]))
}
}

})